import * as React from "react";

import "./image-zoom.scss"

let animationFrame:number|null = null;

export const ImageZoom = ({renderImage}:{
    renderImage     : () => React.ReactNode,
}) => {
    const ref = React.useRef<HTMLDivElement|null>(null);

    React.useEffect(() =>
    {
        if (!ref.current) return;

        const handleMouseMove = (e:MouseEvent) =>
        {
            const div               = e.currentTarget as HTMLDivElement;
            const {pageX, pageY}    = e;

            if (animationFrame) {
                cancelAnimationFrame(animationFrame);
            }

            animationFrame = requestAnimationFrame(() =>
            {
                animationFrame = null;

                const rect = div.getBoundingClientRect()
                document.documentElement.style.setProperty(
                    '--image-zoom-x',
                    (100 * (pageX - rect.x - window.scrollX) / rect.width).toFixed(1)
                ),
                document.documentElement.style.setProperty(
                    '--image-zoom-y',
                    (100 * (pageY - rect.y - window.scrollY) / rect.height).toFixed(1)
                );
            });
        };

        ref.current.addEventListener("mousemove", handleMouseMove);
        return () => ref.current.removeEventListener("mousemove", handleMouseMove);
    }, [ref.current]);

    return (
        <div ref={ref} className='image-container-zm105'>
            {renderImage()}
        </div>
    )
}

